import posthog from 'posthog-js';

let posthogInitialized = false;

if (typeof window !== 'undefined' && !posthogInitialized) {
  const token = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
  const apiHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;
  if (token && apiHost) {
    posthog.init(token, { api_host: apiHost });
    posthogInitialized = true;
  } else {
    console.error('PostHog token or host is missing!');
  }
}

export default posthog; 